import React from 'react';
import ReactDOM from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import './index.css';
import { UitslagenArchief } from './App';
import Startlijst from './components/Startlijst';
import EilandersAllerTijden from './components/EilandersAllerTijden';

const archiefContainer = document.getElementById('eureka-archief-root');
const startlijstContainer = document.getElementById('hre-startlijst-root');
const eilandersContainer = document.getElementById('hre-eilanders-root');

const containerCount = [archiefContainer, startlijstContainer, eilandersContainer].filter(Boolean).length;
if (containerCount > 1) {
  throw new Error('HRE Eureka: meerdere shortcode-containers gevonden. Gebruik exact 1 per pagina.');
}

if (archiefContainer) {
  ReactDOM.createRoot(archiefContainer).render(
    <React.StrictMode>
      <MemoryRouter><UitslagenArchief /></MemoryRouter>
    </React.StrictMode>,
  );
} else if (startlijstContainer) {
  const serie = startlijstContainer.dataset.serie || 'all';
  const speaker = startlijstContainer.dataset.speaker === 'true';
  const jaar = parseInt(startlijstContainer.dataset.jaar || '2026', 10);
  ReactDOM.createRoot(startlijstContainer).render(
    <React.StrictMode>
      <Startlijst serie={serie} speaker={speaker} jaar={jaar} />
    </React.StrictMode>,
  );
} else if (eilandersContainer) {
  ReactDOM.createRoot(eilandersContainer).render(
    <React.StrictMode>
      <EilandersAllerTijden />
    </React.StrictMode>,
  );
} else {
  // eslint-disable-next-line no-console
  console.warn('HRE Eureka: geen bekende mount container gevonden.');
}
